<script lang="ts">
import VCard from "@/lib/components/VCard/VCard.vue";

export default defineComponent({
	name: "CardSample",

	components: { VCard },
});
</script>

<template>
	<VCard closable>
		<template v-slot:header>Card Header</template>
		<template v-slot:footer>Card Footer</template>
		This is card content
	</VCard>
</template>

<style scoped lang="scss"></style>
